// extracted by mini-css-extract-plugin
export default {"root":"nMGB8Y3jM5P6R6SfM7mc"};